__turbopack_context__.v({
  "articleContent": "BlogDetails-module__THRPAG__articleContent",
  "relateProductCard": "BlogDetails-module__THRPAG__relateProductCard",
});
